/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

enum ErrorAction {
    Nothing = "NOTHING",
    GoToMainPage = "GOTOMAINPAGE",
    Reload = "RELOAD"
}

export default ErrorAction;